import { Dict } from "../api/model";

export class Lazy<T> {
    private val: T
    constructor(private lazy_func: () => T) {
    }
    get(): T {
        if (this.val == null) {
            this.val = this.lazy_func()
        }
        return this.val
    }
}
export function strEqIgnoreEmptyAndNull(a: string | null, b: string | null): boolean {
    if (a == null) {
        a = ''
    }
    if (b == null) {
        b = ''
    }
    return a == b
}

export function cleanProperties(obj: any) {
    Object.keys(obj).forEach(k => delete obj[k])
}

export function copyProperties(obj: any): any {
    const newObj: any = {}
    Object.keys(obj).forEach(k => newObj[k] = obj[k])
    return newObj
}

export function sortByDate(list: Array<any>, propName: string, desc: boolean = false): Array<any> {
    return list.slice().sort((x, y) => {
        let xv: Date = x[propName]
        let yv: Date = y[propName]
        if (!(xv instanceof Date)) {
            xv = new Date(xv)
        }
        if (!(yv instanceof Date)) {
            yv = new Date(yv)
        }
        if (desc) {
            return yv.getTime() - xv.getTime()
        } else {
            return xv.getTime() - yv.getTime()
        }
    })
}

export function convertToMultiMap(list: Array<any>, key: string): Dict<Array<any>> {
    const map: Dict<Array<any>> = {}
    list.forEach(item => {
        const kv = item[key]
        if (map[kv] == null) {
            map[kv] = []
        }
        map[kv].push(item)
    })
    return map
}

export function delay(interval: number): Promise<void> {
    return new Promise(resolve => {
        setTimeout(resolve, interval)
    })
}